export default __webpack_public_path__ + "static/media/apply1.87b32026.png";